const tileData = [
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Breakfast',
        author: 'jill111',
        featured: true,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Tasty burger',
        author: 'director90',
        featured: false,// featured is optional
    },
    {
        img: 'http://via.placeholder.com/600x400',
        title: 'Camera',
        author: 'Danson67',
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Morning',
        author: 'fancycrave1',
        featured: true,
    },
    {
        img: 'http://via.placeholder.com/600x400',
        title: 'Hats',
        author: 'Hans',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Honey',
        author: 'fancycravel',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Vegetables',
        author: 'jill111',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Water plant',
        author: 'BkrmadtyaKarki',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/600x400',
        title: 'Mushrooms',
        author: 'PublicDomainPictures',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Olive oil',
        author: 'congerdesign',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Sea star',
        author: '821292',
        featured: false,
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Bike',
        author: 'danfador',
        featured: false,
    },
];

export default tileData;



// WEBPACK FOOTER //
// ./app/routes/components/routes/gridList/advance/tileData.js